// @flow
import { createAction } from 'redux-actions';
import moment from 'moment';
import type { Dispatch } from 'redux';
import type { $AxiosError } from 'axios';
import { format } from '../../../../../../../../browser/shared/util/gigwalkApiErrorUtil';
import entitySelector from '../../../../../../../redux/entities/entitySelector';
import {
    fetch as fetchTicket,
    update as updateTickets,
} from '../../../../../../../redux/entities/tickets';
import * as snackbar from '../../../../../../../ducks/snackbar';
import types from './types';
import type { State as RootState } from '../../../../../../../redux/initialState';

const ticketSelector = entitySelector('tickets');

export const submitError = createAction(types.SUBMIT_ERROR);
export const submitSuccess = createAction(types.SUBMIT_SUCCESS);
export const submit = createAction(
    types.SUBMIT,
    (values: Object, props: Object): Function => (
        (dispatch: Dispatch<any>, getState: () => RootState): Promise<any> => {
            const { scheduledDate } = values;
            const { match } = props;
            const ticketId = parseInt(match.params.ticketId, 10);
            const ticket = ticketSelector(getState(), ticketId);

            const params = {
                action: 'schedule',
                ticket_ids: [ticketId],
                date_scheduled: moment(scheduledDate).format('YYYY-MM-DDTHH:mm:ss'),
                time_zone: ticket.location.tzid,
            };

            return dispatch(updateTickets(params))
                .then(() => dispatch(fetchTicket({ ticket_id: ticketId })))
                .then(() => {
                    dispatch(submitSuccess());
                })
                .catch((err: $AxiosError<Object>) => {
                    dispatch(submitError(err));
                    const resp = err ? err.response : null;
                    if (resp && resp.data && resp.data.gw_api_response) {
                        const message = format(resp.data.gw_api_response);
                        dispatch(snackbar.actions.enqueue(message, { variant: 'error' }));
                    }
                    return Promise.reject();
                });
        }
    )
);

export default {
    submit,
    submitError,
    submitSuccess,
};
